import React from "react";

const NoVideoItem = (props) => {
    return (
        <>
        <div className="wcVdoBoxItem">
            <div className="wcVdoBox16x9">
                <div className="noMediaBox">
                    <img src="/images/icons/no-video-file.png" alt="icon" />
                </div>
            </div>
            <div className="wcVdoHdngBox">
                <span className="wcVdoHdng">{props.noVideoLabel}</span>
            </div>
        </div>
        </>
    )
}
export default NoVideoItem;